import * as React from "react";
import { UitkFullscreenDialog, UitkDialogContent } from "uitk-react-dialog";
import { UitkToolbar, ToolbarType } from "uitk-react-toolbar";
import { Layer } from "bernie-view";
import { RouteStore, DialogRoute } from "bernie-core";
import { inject, observer } from "mobx-react";
import { UitkHeading } from "uitk-react-text";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { DialogAction } from "./DialogAction";
import { getLineOfBusiness, getFunnelLocation } from "./NotificationQueryUtils";
import { gql } from "apollo-boost";
import { useQuery } from "react-apollo";
import {
  ContextInput,
  BlossomCustomerNotification,
  NotificationLocation,
  blossomCustomerNotificationQuery,
} from "__generated__/api";
import Customer = BlossomCustomerNotification.Customer;
import Notification = BlossomCustomerNotification.Notification;
import { ClientChatbotStore } from "src/stores/chatbotStore/ClientChatbotStore";

export interface NotificationDialogProps {
  inputs: {
    context: ContextInput;
    lineOfBusiness: string;
    funnelLocation: string;
  };
  dialogId?: string;
  chatbot?: ClientChatbotStore;
  routeStore?: RouteStore;
  analyticsCallback?: (rfrr: string, linkName: string | null) => void;
}

export const NotificationDialog: React.FunctionComponent<NotificationDialogProps> = inject("routeStore")(
  observer((props: NotificationDialogProps) => {
    const { routeStore, dialogId } = props;
    if (!routeStore) {
      return null;
    }

    const queryCustomerNotifications = gql`
      ${blossomCustomerNotificationQuery}
    `;

    const variables = {
      context: props.inputs.context,
      notificationLocation: NotificationLocation.POPUP,
      lineOfBusiness: getLineOfBusiness(props.inputs.lineOfBusiness),
      funnelLocation: getFunnelLocation(props.inputs.funnelLocation),
    };
    const { data, error, loading } = useQuery<{ customer: Customer }>(queryCustomerNotifications, { variables });

    if (error || loading || !data || !data?.customer.notification) {
      return null;
    }

    // eslint-disable-next-line
    const { title, links } = data?.customer.notification || ({} as Notification);

    const heading = title?.items[0].text;

    const onDismissFullscreen = () => {
      routeStore!.closeDialog();
    };

    return (
      <>
        <DialogRoute id={dialogId} type="pwaDialog" useQueryBuilder={true}>
          <Layer id="fullscreenDialog" onDismiss={onDismissFullscreen}>
            <UitkFullscreenDialog dialogShow={true} heightAuto={true} className={"all-y-padding-zero"}>
              <UitkToolbar action={onDismissFullscreen} key="UitkToolbar" type={ToolbarType.CLOSE} />
              <UitkDialogContent key="covid-credit-container" className="notification-dialog">
                <div key="cta-dialog-heading" className="all-t-padding-six">
                  <UitkHeading level={1} size={700}>
                    {heading}
                  </UitkHeading>
                </div>
                <UitkLayoutFlex space="two" wrap="wrap" className="all-y-padding-six">
                  <>
                    {links?.map((link, index) => {
                      return (
                        <DialogAction
                          key={`customer-notification-action-link-${index}`}
                          analyticsCallback={props.analyticsCallback}
                          link={link}
                        />
                      );
                    })}
                  </>
                </UitkLayoutFlex>
              </UitkDialogContent>
            </UitkFullscreenDialog>
          </Layer>
        </DialogRoute>
      </>
    );
  })
);
